import React, { useEffect, useState, useMemo,useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link,useParams } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import axios from "axios";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper"
import MySubscription from "./MySubscription";
import * as url from "../../../../src/helpers/url_helper";
import Spinners from "../../../components/Common/Spinner";


const StudentView = () => {
   const { sid } = useParams();
  
   const [isLoading, setLoading] = useState(false);
   const user = getLoggedInUser();
   const [studentName ,setStudentName] = useState('');
   const [studentType ,setStudentType] = useState('');
   const [isVerified,setIsVerified] = useState(0);
   const [isSubscribed,setIsSubscribed] = useState(0);
   const [email,setEmail] = useState('');
   const [mobileno,setMobileno] = useState('');
   const [language,setLanguage] = useState('');
   const [qualification,setQualification] = useState('');
   const [totalCount, setTotalCount] = useState(0);
   const [activeCount, setActiveCount] = useState(0);
   const [inactiveCount, setInactiveCount] = useState(0);
   const [ userProfile, setUserProfile ] = useState({});
   const timeoutRef = useRef(null); // Track existing timeout
    const [valueToPass, setValueToPass] = useState(null);
  
  useEffect(() => {
      document.getElementById('headerTitle').innerHTML = 'Student Details';
      getStudentData()
  }, [sid]);
 const sendValueToMySubscription = (value) => {
    // Clear any previous timeout before setting new value
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setValueToPass(value);

    // Automatically reset the value after 100ms
    timeoutRef.current = setTimeout(() => {
      setValueToPass(null);
    }, 1000);
  };
 const getStudentData = async () => {
    try{
      setLoading(true);
        const data = { user_id: Number(user.uid), stid: Number(sid) }
        const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } }
        const response1 = await axios.post(url.BASE_URL + 'student/getStudentDetails', data, config)
         if (response1?.data?.body?.status === '401' || response1?.data?.body?.status === 401) {
                 setLoading(false);
                const refresh = await getRefreshToken() // Calling refreshToken if accessToken Expired
                if (refresh) {
                    if (Number(refresh) === constants.invalidRefreshToken) {
                        logoutUser()
                    } else {
                        await getStudentData() // calling same function again getting refresh token
                    }
                }
            }
          
        if (response1 && response1.data && response1.data && response1.data.status === 200) {
          let student = response1?.data?.body?.student;
          if(student.length>0){
            setStudentName(student[0]?.name);
            if(student[0]?.st_employee_type_id == 0){
                    setStudentType(student[0]?.student_type_text);
            }
            else{
                    setStudentType(student[0]?.employee_type_text+' '+student[0]?.student_type_text);
            }
            setIsVerified(student[0]?.verified_status);
            setIsSubscribed(student[0]?.subscribed);
            setEmail(student[0]?.email);
            setLanguage(student[0]?.language);
            setMobileno(student[0]?.mobileno);
            setQualification(student[0]?.qualification);

          }
          setTotalCount(response1?.data?.body?.totalSub);
          setActiveCount(response1?.data?.body?.activeSub);
          setInactiveCount(response1?.data?.body?.expireSub);
          setUserProfile({subscriptions:response1?.data?.body?.subHistory});
          setLoading(false);
        } 
    }
    catch(e)
    {
         setLoading(false);
        console.log(e,'e')
    }
}
 
  return (
    <React.Fragment>

    <div className="page-content">
      <Container fluid>
        {/* Render Breadcrumbs */}
        
        <Row>
          <Col xl="4">
            <Card className="overflow-hidden">

              <CardBody className="pt-0">
                <Row>
                  <Col sm="4" className="mb-2 pt-4">
                
                    <h5 className="font-size-15">
                      {studentName}
                    </h5>
                    <p className="text-muted mb-0 text-truncate">
                      {studentType}
                    </p>
                  </Col>

                  <Col sm={8}>
                    <div className="pt-4">
                      <Row>
                        {
                          isVerified == 1? <Col xs="6" style={{ textAlign: "center" }}>
                          <h5 className="font-size-15">
                         <i className="bx bx-badge-check text-success"></i>
                          </h5>
                          <p className="text-muted mb-0">Verified</p>
                        </Col>:
                          <Col xs="6" style={{ textAlign: "center" }}>
                            <h5 className="font-size-15">
                          <i className="bx bx-badge-check text-danger"></i>
                            </h5>
                            <p className="text-muted mb-0">Pending</p>
                          </Col>
                        }
                       {
                        isSubscribed == 1?  <Col xs="6" style={{ textAlign: "center" }}>
                          <h5 className="font-size-15">
                         <i className="mdi mdi-shield-star-outline text-success"></i>
                          </h5>
                          <p className="text-muted mb-0">Subscribed</p>
                        </Col>:
                         <Col xs="6" style={{ textAlign: "center" }}>
                          <h5 className="font-size-15">
                         <i className="mdi mdi-shield-star-outline text-danger"></i>
                          </h5>
                          <p className="text-muted mb-0">{isSubscribed == 0? 'Not yet subscribed' : 'Subscription Expired'}</p>
                        </Col>
                       }
                       
                      </Row>
                      
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                 {  isLoading?  <Spinners setLoading={setLoading} />:'' }

                <CardTitle className="mb-4">Personal Information</CardTitle>
                <p className="text-muted mb-4">
                </p>
                <div className="table-responsive">
                  <Table className="table-nowrap mb-0">
                    <tbody>
                      
                      <tr>
                        <th scope="row">Mobile :</th>
                        <td>{mobileno}</td>
                      </tr>
                      <tr>
                        <th scope="row">E-mail :</th>
                        <td>{email}</td>
                      </tr>
                      <tr>
                        <th scope="row">Qualification  :</th>
                        <td>{qualification}</td>
                      </tr>
                      <tr>
                        <th scope="row">Medium  :</th>
                        <td>{language}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                <CardTitle className="mb-5">Subscriptions</CardTitle>
                <div >
                  <ul className="verti-timeline list-unstyled">
                     {userProfile?.subscriptions?.length == 0?
                       <div style={{ fontSize: '14px', fontStyle: 'italic' }} >No subscriptions found.</div>
                       :''}
                    {(userProfile?.subscriptions || [])?.map((experience, i) => (
                      <li
                        className={
                          experience.statusid === 1
                            ? "event-list active"
                            : "event-list"
                        }
                        key={"_exp_" + i}
                      >
                        <div className="event-timeline-dot">
                          <i
                            className={
                              experience.statusid === 1
                                ? "bx bx-right-arrow-circle bx-fade-right"
                                : "bx bx-right-arrow-circle"
                            }
                          />
                        </div>
                        <div className="d-flex">
                         
                          <div className="flex-grow-1">
                            <div>
                              <h5 className="font-size-15">
                                <Link
                                  to={experience.plan_id}
                                  className="text-dark"
                                >
                                  {experience.plan_name }
                                </Link>
                                <span style={{float:"right"}}>{'₹'}{experience.amount}</span>
                              </h5>
                              
                              <span className={experience.statusid ==1 ? "text-warning" : "text-danger"}>
                                {experience.statusid ==1?"Expiring on "+experience.expired_date:"Expired on "+experience.expired_date}
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xl="8">
         
        
          
          <Row>
          <Col md="4">
        <Card className="mini-stats-wid" onClick={() => sendValueToMySubscription(10)}>
          <CardBody>
            <div className="d-flex" >
              <div className="flex-grow-1">
                <p className="text-muted fw-medium mb-2">{'Total Subscribed'}</p>
                <h4 className="mb-0">{totalCount}</h4>
              </div>
              <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                <span className="avatar-title">
                  <i className={"bx bx-package font-size-24"} />
                </span>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col md="4">
        <Card className="mini-stats-wid" onClick={() => sendValueToMySubscription(1)}>
          <CardBody>
            <div className="d-flex" >
              <div className="flex-grow-1">
                <p className="text-muted fw-medium mb-2">{'Active Subscription'}</p>
                <h4 className="mb-0">{activeCount}</h4>
              </div>
              <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                <span className="avatar-title">
                  <i className={"bx bx-check-circle font-size-24"} />
                </span>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col md="4">
        <Card className="mini-stats-wid" onClick={() => sendValueToMySubscription(8)}>
          <CardBody>
            <div className="d-flex">
              <div className="flex-grow-1">
                <p className="text-muted fw-medium mb-2">{'Expired Subscription'}</p>
                <h4 className="mb-0">{inactiveCount}</h4>
              </div>
              <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                <span className="avatar-title">
                  <i className={"bx bx-hourglass font-size-24"} />
                </span>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
</Row>
         <Card>
       <MySubscription value={valueToPass} />
            </Card>    
          </Col>
        </Row>
      </Container>
    </div>
  </React.Fragment>
  );
};

export default StudentView;
